export const redirectTo404 = () => {
    window.location.replace('/404'); //  REDIRECT TO ERR PAGE
}